import * as React from "react";
import { Alert } from "../../../Components/Alert";
import { AlertType } from "../../../Entities/Constants/AlertConstants";

interface IInvalideCodeWarning {
    codes: string[];
}

export const InvalideCodeWarning = (props: IInvalideCodeWarning) => {
    const [show, setShow] = React.useState(false);

    return (
        <Alert
            alertType={AlertType.Warning}
            message={
                <>
                    {props.codes.length} of these fund could not be found. <br />
                    <p>
                        Please expand this message to see the full list{" "}
                        <a className={`expand-button ${show ? "close" : "open"}`} onClick={() => setShow(!show)} />
                    </p>
                    {show && (
                        <ul>
                            {props.codes.map((code) => {
                                return <li key={code}>{code}</li>;
                            })}
                        </ul>
                    )}
                </>
            }
        />
    );
};
